import React from 'react';
import QuestionWrapper from '../response/QuestionWrapper';
import ConnectedHeatMap from './ConnectedHeatMap';

const HeatMapQuestion = props => {
  return (
    <QuestionWrapper {...props}>
      <ConnectedHeatMap {...props} />
    </QuestionWrapper>
  );
};

export default HeatMapQuestion;
